
var $=jQuery;
var left_width=0;
var url = window.location.href;
var skuId,option1,option2,option3,productId;
var quantity=1;
var isClicked = false; // 标识是否已点击

  jQuery(function(){
    $('.gift-pic').click(function(){
      let imgSrc = $(this).attr("data-pic");

      console.log("data-pic 的原始值:", imgSrc);
   // 如果 data-pic 为空，则使用默认图片
      imgSrc = imgSrc ? imgSrc : "https://cdn.shopify.com/s/files/1/1720/3725/files/pc_2_c3f6b5be-06c3-47a6-b794-24f0eddae041.png?v=1744197108";
      // 确保 data-pic 存在
      if (!imgSrc) {
          console.warn("⚠️ data-pic 为空！");
          return;
      }
  
      console.log("最终的图片地址:", imgSrc);
      $('.PageOverlay').addClass('is-visible');
      $("body").append(`
        <div class="pop-main">
            <div class="pop_con">
                <div class="pop_title">
                    <button type="button" class="window-cover_con-close iconfont icon-close"></button>
                </div>
                <div class="pop_detail">
                    <img class="Image--lazyLoad Image--fadeIn pic_site" data-sizes="auto"
                        src="https://cdn.shopify.com/s/files/1/1720/3725/files/pc_9dcca561-bd9b-42f4-afcd-ceba5b9011b8.png?v=1744092520"
                        data-src="${imgSrc}"
                        width="450" height="400" alt="Klaiyi Newest Coupon Code">
                </div>
            </div>
        </div>
      `);
    
      
    })
    // 点击关闭按钮，移除 `.pop-main`
  $(document).on("click", ".pop-main .window-cover_con-close", function () {
     // 点击关闭礼物弹窗
    $(".pop-main").remove();
    $('.PageOverlay').removeClass('is-visible');
  });
    // 修复直接带数量的连接
    var qtyValue = getQueryVariable('qty');
    quantity = qtyValue;
    if(qtyValue){
      $(".product_cen_detail .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity").attr("value",qtyValue);
    }
    $('.may_like ul li').each(function () {
      if($(this).attr('data-id')==$('.buy_now').attr('product-id')){
        $(this).remove();
      }
    })
    // 点击产品评价跳到评价位置
    $('.rating_share .rating__caption').click(function(){
       var flag = true //设置标识。防止出现跑马灯  
        var top_pc = $(".tab-review").offset().top-$("#section-header").height()-100;//获取每个banner到顶部的距离 
        var top_m = $(".tab-review").offset().top-$("#section-header").height();//获取每个banner到顶部的距离 
       if(jQuery(window).width()<=768){
             $("html,body").stop(true).animate({"scrollTop":top_m},function(){flag = true})  
       }
      if(jQuery(window).width()>=769){
             $("html,body").stop(true).animate({"scrollTop":top_pc},function(){flag = true})  
       }
    })
          // 点击add to cart进入结算页
        $('.Product__InfoWrapper .add_tocart').off("click").on("click",function(){
         var sku_id = getQueryVariable("variant");
          if(sku_id){
            skuId=sku_id
          }else{
              skuId=$(this).attr('sku-id');
          }
       
          productId=$(this).attr('product-id');
          quantity=$(".product_cen_detail .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity").attr("value");
          var now_price=jQuery('.ProductForm .ProductMeta__PriceList .Price--highlight .money').text();
          var newStr_price = now_price.replace(/[$,]/g, ''); // 去掉逗号
          var finally_price = '$' + (newStr_price*($('.product_cen_detail .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity').val())).toFixed(2);
          product_cart_DataLyer_push('add_to_cart',finally_price,$('.ProductForm .ProductMeta .ProductMeta__Title .product_name').text(),productId,$('.product_cen_detail .ProductForm__BuyButtons').attr('sku-word'),quantity);
          product_add_cart();
        })
    // 点击buy now 按钮进入结账页
      $('.Product__InfoWrapper .buy_now').off("click").on("click",function(){
         var sku_id = getQueryVariable("variant");
          if(sku_id){
            skuId=sku_id
          }else{
              skuId=$(this).attr('sku-id');
          }
       
        productId=$(this).attr('product-id');
        quantity=$(".product_cen_detail .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity").attr("value");
          var now_price=jQuery('.ProductForm .ProductMeta__PriceList .Price--highlight .money').text();
          var newStr_price = now_price.replace(/[$,]/g, ''); // 去掉逗号
          var finally_price = '$' + (newStr_price*($('.product_cen_detail .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity').val())).toFixed(2);
        product_cart_DataLyer_push('Buy Now',finally_price,$('.ProductForm .ProductMeta .ProductMeta__Title .product_name').text(),productId,$('.ProductForm__BuyButtons').attr('sku-word'),quantity);
        product_buy();
      })
        localStorage.removeItem('navImg_index');
      
    // 点击分期介绍
      $('.fenqi_pic').off("click").on("click",function(){
        pay_type_popon();
      })
    // 小图切换，小图滚动
    $(".Product__SlideshowNavImage").each(function(index,list,){
      $(this).off("click").on("click",function(){
        var nav_index = localStorage.getItem('navImg_index');
          if(nav_index>index){
            if($(".Product__SlideshowNavImage").length-index>3){
              if(index>=3){
                left_width+=67*(nav_index-index);
                  $('.Product__SlideshowNavScroller').css('top',left_width);
              }else{
                left_width=0;
                $('.Product__SlideshowNavScroller').css('top',left_width);
              }

    
              }
          }else{
            if($(".Product__SlideshowNavImage").length-index>3){
              if(index>=3){
                if(index-nav_index>1){
                   left_width-=67*(index-nav_index);
                  $('.Product__SlideshowNavScroller').css('top',left_width);
                }else{
                   left_width-=67;
                  $('.Product__SlideshowNavScroller').css('top',left_width);
                }

              }else{
                left_width=0;
                $('.Product__SlideshowNavScroller').css('top',left_width);
              }

            }
  
          }
          localStorage.setItem('navImg_index', index);
          DataLyer_push_productDetailClick(index+1);
      })
      })
    if(url.indexOf("flash-sale") >= 0 ) { 
      jQuery(".proDetail-info_gift .coupon_tishi").hide();
      jQuery(".flash_sale_tishi").show();
    }else{
     jQuery(".flash_sale_tishi").hide();
     jQuery(".proDetail-info_gift .coupon_tishi").show();
    }
    // 点击分享按钮
      jQuery('.rating_share .share').off("click").on("click",function(){
         popon7();
       })
    // 点击卖点服务弹出弹窗
     jQuery(".product_introduce_cen").each(function(index){
        jQuery(this).find('li').each(function(index){
           jQuery(this).off("click").on("click",function(){
             popon6(index);
           })
         })
     })

    function popon6(index){
      $('.sales_service_popup_title li').eq(index).addClass('active').siblings().removeClass('active');
      $('.sales_service_popup_con li').eq(index).addClass('active').siblings().removeClass('active');
         jQuery('.sales_service_popup .window-cover').show();
         jQuery('.sales_service_popup .pop_main').show();
         jQuery('.sales_service_popup .pop_main .pop_con').css({'top':0,'opacity':0})
         jQuery('.sales_service_popup .pop_main .pop_con').animate({'top':'50%','opacity':1})
    }
    function popon7(){
         jQuery('.share_popup .window-cover').show();
         jQuery('.share_popup .pop_main').show();
         jQuery('.share_popup .pop_main .pop_con').css({'top':0,'opacity':0})
         jQuery('.share_popup .pop_main .pop_con').animate({'top':'50%','opacity':1})
          // 点击复制连接
      $('.copy_link').off("click").on("click",function(){
        copyText($(this).attr('data-link'));
      })
    }
        // 尺寸弹窗
      jQuery(".size").off("click").on("click",function(){
        jQuery('.size_proup').css('display','block');
        jQuery('.size_proup .window-cover').css('display','block');
        jQuery('.size_proup .pop_main').css('display','block');
        jQuery('.size_proup .pop_con').css('opacity','1');
      })
    // 推荐产品
       jQuery(".shopify-section").each(function(index){
          if(jQuery(this).attr('id')=='shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7'){
              jQuery(this).find('.addCart_icon').removeClass('none').css('display','inline-block');
              jQuery(this).find('.ProductItem__PriceList').css('position','relative');
          }
        })
    // 属性循环添加特殊标记
      jQuery(".ProductForm__Variants").each(function () {
        var tmp;
        jQuery(this).find('.SizeSwatch').each(function() {
          tmp = jQuery(this).text();
          if(tmp.indexOf("T Part") >= 0 ) { 
            jQuery(this).after('<div class="t_part_wenhao">?</div>');
      
          }else if(tmp.indexOf("Part Lace") >= 0 ){
            jQuery(this).after('<div class="lace_part_wenhao">?</div>');
          }
        });
      
      });
      jQuery(document).on("click", '.t_part_wenhao',function (e) {
        jQuery('.window-cover').css('display','block');
          jQuery('.Product--large').append('<div class="pc_t_part_new_SizeSwatch window-cover_con"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/t-part.jpg?v=1744618397" /><span class="iconfont icon-close_line">X</span></div>')
            e?e.stopPropagation():event.cancelBubble = true;  
      })
      jQuery(document).on("click", '.lace_part_wenhao',function (e) {
        jQuery('.window-cover').css('display','block');
        jQuery('.Product--large').append('<div class="pc_lace_part_new_SizeSwatch window-cover_con"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/lace_part.jpg?v=1744618397" /><span class="iconfont icon-close_line">X</span></div>')
          e?e.stopPropagation():event.cancelBubble = true;  
      })
      jQuery(document).on("click", '.window-cover_con .icon-close_line',function () {
        jQuery('.pc_t_part_new_SizeSwatch').addClass('none');
        jQuery('.pc_lace_part_new_SizeSwatch').addClass('none');
        jQuery('.window-cover').css('display','none');
      })
      jQuery(document).click(function() {    
        jQuery('.pc_t_part_new_SizeSwatch').addClass('none');
        jQuery('.pc_lace_part_new_SizeSwatch').addClass('none');   
      });
        // 赠品隐藏购买按钮
  if(jQuery('.ProductForm').attr('id')=="product_form_6902664462470"||jQuery('.ProductForm').attr('id')=="product_form_6834709561478"||jQuery('.ProductForm').attr('id')=="product_form_6882601009286"
    ||jQuery('.ProductForm').attr('id')=="product_form_6882316058758"||jQuery('.ProductForm').attr('id')=="product_form_6855975895174"||jQuery('.ProductForm').attr('id')=="product_form_6870570762374"||
    jQuery('.ProductForm').attr('id')=="product_form_6870920691846"||jQuery('.ProductForm').attr('id')=="product_form_6880133644422"||jQuery('.ProductForm').attr('id')=="product_form_6953560506502"||
    jQuery('.ProductForm').attr('id')=="product_form_6834709561478"||jQuery('.ProductForm').attr('id')=="product_form_6834670076038"||jQuery('.ProductForm').attr('id')=="product_form_6953561686150"||
    jQuery('.ProductForm').attr('id')=="product_form_6954103996550"||jQuery('.ProductForm').attr('id')=="product_form_6947754803334"||jQuery('.ProductForm').attr('id')=="product_form_6822162792582"||jQuery('.ProductForm').attr('id')=="product_form_6985551741062"){
     jQuery('.ProductForm__BuyButtons').remove();
   }
    // You May Also Like产品
    // 详情页刚开始只展示4个产品
       $("#shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7 .Grid__Cell:gt(3)").hide();
        var sLen = $("#shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7 .Grid__Cell:gt(3)").length;
    // 点击按钮多展示4个
        $("#shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7 .SectionFooter .Button--primary").attr('href','javascript:;')
        $("#shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7 .SectionFooter .Button--primary").click(showMore);

        function showMore() {
            var i = $(this).data("index");
                num = (i + 1) * 4;
                $("#shopify-section-template--14334016979078__04d12cbf-43d7-4c45-be97-ecfef4720cd7 .ProductList").children(":lt(" + num + ")").show();
            i++;
            $(this).data("index", i);
        }
     var product_attribute= document.querySelector('.ProductForm #json-script');
     const jsonStr = JSON.parse(product_attribute.innerText);
        option1= $('.Product__Info .ProductForm__Option:eq(0)').find('input:checked').siblings(".SizeSwatch").text();
        option2= $('.Product__Info .ProductForm__Option:eq(1)').find('input:checked').siblings(".SizeSwatch").text() || '';
        option3= $('.Product__Info .ProductForm__Option:eq(2)').find('input:checked').siblings(".SizeSwatch").text() || '';
        if(option1){
          $('.ProductForm__BuyButtons').attr('option-one',option1);
       }
       if(option2){
          $('.ProductForm__BuyButtons').attr('option-two',option2);
       }
       if(option3){
          $('.ProductForm__BuyButtons').attr('option-three',option3);
       }
    var new_quantity_arr=[];
    jsonStr.product.variants.forEach(function (variant,index) {
      if(variant.inventory_quantity<=0){
        new_quantity_arr.push(variant.options);
      }
    })
     for(let i = 0; i < new_quantity_arr.length; i++) {
       if(new_quantity_arr[i][0]==option1&&new_quantity_arr[i][1]==option2){
         jQuery(".Product__Info .ProductForm__Option:eq(2) .SizeSwatch").each(function (j) {
           if($(this).text()==new_quantity_arr[i][2]){
             $(this).addClass('label_disabled');
           }
         })
       }
    }
            // 详情描述的tab
      if(jQuery('.ProductForm').attr('id')=="product_form_6826033578118"){
        $('.description_collapsible__Inner .Collapsible__Content').append('<div class="product_des_tab"><ul class="title_tab"><li class="active">7x5 ByeBye Knots Wig 3.0</li><li>6x4.75 Pre-cut Glueless Wig 2.0</li></ul><ul class="tab_con"><li class="active tab_con_pic1"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_66.png?v=1697615842"></li><li class="tab_con_pic2"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/4_cbb6e5d0-0c04-4c53-850d-fd885e50b54e.png?v=1697615918"></li></ul></div>');
      }
      if(jQuery('.ProductForm').attr('id')=="product_form_6817113800838"){
        $('.description_collapsible__Inner .Collapsible__Content').append('<div class="product_des_tab"><ul class="title_tab"><li class="active">7x5 ByeBye Knots Wig 3.0</li><li>6x4.75 Pre-cut Glueless Wig 2.0</li></ul><ul class="tab_con"><li class="active tab_con_pic1"><img src="https://cdn.shopifycdn.net/s/files/1/1720/3725/files/Frame_63.png?v=1697615129"></li><li class="tab_con_pic2"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/3_7a479cbc-2628-4bba-b27b-e2a042963c8c.png?v=1697615637"></li></ul></div>');
      }
      if(jQuery('.ProductForm').attr('id')=="product_form_6870173712518"){
        $('.description_collapsible__Inner .Collapsible__Content').append('<div class="product_des_tab"><ul class="title_tab"><li class="active">7x5 ByeBye Knots Wig 3.0</li><li>6x4.75 Pre-cut Glueless Wig 2.0</li></ul><ul class="tab_con"><li class="active tab_con_pic1"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_64.png?v=1697509963"></li><li class="tab_con_pic2"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/2_299f46eb-65c9-43df-9730-11726bf92c4a.png?v=1697523265"></li></ul></div>');
      }
      if(jQuery('.ProductForm').attr('id')=="product_form_6832635183238"){
        $('.description_collapsible__Inner .Collapsible__Content').append('<div class="product_des_tab"><ul class="title_tab"><li class="active">7x5 ByeBye Knots Wig 3.0</li><li>6x4.75 Pre-cut Glueless Wig 2.0</li></ul><ul class="tab_con"><li class="active tab_con_pic1"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_66.png?v=1697615842"></li><li class="tab_con_pic2"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/4_cbb6e5d0-0c04-4c53-850d-fd885e50b54e.png?v=1697615918"></li></ul></div>');
      }
      if(jQuery('.ProductForm').attr('id')=="product_form_6858272931974"){
        $('.description_collapsible__Inner .Collapsible__Content').append('<div class="product_des_tab"><ul class="title_tab"><li class="active">7x5 ByeBye Knots Wig 3.0</li><li>6x4.75 Pre-cut Glueless Wig 2.0</li></ul><ul class="tab_con"><li class="active tab_con_pic1"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/7x5_stm.jpg?v=1698460560"></li><li class="tab_con_pic2"><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/34_108470ba-364d-4dda-8bb6-5e83c3c8ec1d.jpg?v=1698461386"></li></ul></div>');
      }
     
     if(jQuery('.ProductForm').attr('id')=="product_form_6746711949446"){
          var option_label=$('.ProductForm__Variants .ProductForm__Option').eq(1);
          option_label.find('.HorizontalList__Item').eq(0).find('.markers').removeClass('none');
     }
     
     // 提取文件名
function extractFileName(url) {
    if (!url) return "unknown";
    return decodeURIComponent(url.split('/').pop().split('?')[0]);
}
    // m端曝光监听
      // 创建IntersectionObserver实例
      const mDetailObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          // 判断元素是否已经曝光过
          if (entry.isIntersecting && !entry.target.classList.contains('exposed')) {
            // 只在元素首次进入视口时执行
                let mediaIndex = entry.target.getAttribute('data-media-position');
                let mediaType = entry.target.classList.contains("Product__SlideItem--video") ? "video" : "image";
                let mediaSrc = "";
            // 获取视频或图片的 src 并提取文件名
                if (mediaType === "video") {
                    let videoElement = entry.target.querySelector("video source");
                    mediaSrc = videoElement ? extractFileName(videoElement.getAttribute("src")) : "unknown_video";
                } else {
                    let imgElement = entry.target.querySelector("img");
                    mediaSrc = imgElement ? extractFileName(imgElement.getAttribute("data-original-src")) : "unknown_image";
                }
            DataLyer_push_productDetail(entry.target.getAttribute('data-media-position'),mediaType,mediaSrc);
            // 给该元素添加标记，防止重复曝光
            entry.target.classList.add('exposed');
          }
        });
      }, {
        root: null, // 使用视口作为根元素
        rootMargin: '0px',
        threshold: 0.5 // 元素至少50%可见时触发回调
      });
      document.addEventListener('click', function (event) {
        console.log('点击了主图');
    // document.addEventListener('pointerup', function (event) {
        let slide = event.target.closest('.Carousel__Cell');
        if (!slide) return;

        let mediaIndex = slide.getAttribute('data-media-position');
        let mediaType = slide.classList.contains("Product__SlideItem--video") ? "video" : "image";
        let mediaSrc = "unknown";

        if (mediaType === "video") {
            let videoElement = slide.querySelector("video source");
            mediaSrc = videoElement ? extractFileName(videoElement.getAttribute("src")) : "unknown_video";
        } else {
            let imgElement = slide.querySelector("img");
            mediaSrc = imgElement ? extractFileName(imgElement.getAttribute("data-original-src")) : "unknown_image";
        }

        DataLyer_push_productDetailClick1(mediaIndex, mediaType, mediaSrc);
    });


    // 监听所有 slider__slide 元素
    if(jQuery(window).width()<=768){
      $('.big_pic_out .Product__Slideshow .flickity-viewport .Carousel__Cell').each(function() {
        mDetailObserver.observe(this);
      });
    }
  })
  // 主图曝光
  function DataLyer_push_productDetail(index,type,src) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "dle_custom_event",
      dlv_en: `product_img`,
      dlv_ec: `productDetail`, 
      dlv_ea: `imgSlide`,
      dlv_el: `${type}::${src}`,
      dlv_va: `${index}`
    });
  }
  // 小图点击曝光事件
  function DataLyer_push_productDetailClick(index) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "dle_custom_event",
      dlv_en: `product_img`,
      dlv_ec: `productDetail`, 
      dlv_ea: `imgClick`,
      dlv_el: `${index}`,
    });
  }
  // 主图点击曝光事件
  function DataLyer_push_productDetailClick1(index,type,src) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "dle_custom_event",
      dlv_en: `pdp_Diagram`,
      dlv_ec: `productDetail`, 
      dlv_ea: `clickDiagram`,
      dlv_el: `${type}::${src}`,
    });
  }
  function product_add_cart(){
      option1=$('.ProductForm__BuyButtons').attr('option-one')||'';
      option2=$('.ProductForm__BuyButtons').attr('option-two')||'';
      option3=$('.ProductForm__BuyButtons').attr('option-three')||'';

    fetch('/cart/add.js', {
        method:'POST',
        headers: {'Content-Type':'application/json'},
        body:JSON.stringify({
        'form_type':"product",
        'id':skuId,
        'option-0':option1,
        'option-1':option2,
        'option-2':option3,
        'product-id':productId,
        'quantity': quantity
        })
    }).then(function(response) {
        // 处理响应
        window.location.href ="/cart/";
    })
    .catch(function(error) {
        console.error('Failed to add shopping cart：', error);
    });
  }
  function product_buy(){
    option1=$('.ProductForm__BuyButtons').attr('option-one')||'';
    option2=$('.ProductForm__BuyButtons').attr('option-two')||'';
    option3=$('.ProductForm__BuyButtons').attr('option-three')||'';
    fetch('/cart/add.js', {
        method:'POST',
        headers: {'Content-Type':'application/json'},
        body:JSON.stringify({
        'form_type':"product",
        'id':skuId,
        'option-0':option1,
        'option-1':option2,
        'option-2':option3,
        'product-id':productId,
        'quantity': quantity
        })
    }).then(function(response) {
        // 处理响应
        window.location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
    })
    .catch(function(error) {
        console.error('Failed to add shopping cart：', error);
    });
  }
// 复制文本
 function copyText(text) {
  var oInput = document.createElement('input');
  oInput.value = text;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.className = 'oInput';
  oInput.style.display='none';
   $('.teast_popup').removeClass('none').text('copy success!').css('z-index','1111');
   // 在指定的毫秒数后隐藏div
  setTimeout(function() {
      $('.teast_popup').hide();
  }, 3000); // 3000毫秒后隐藏div，即3秒钟
}
// 支付方式弹窗
function pay_type_popon(){
   if(jQuery(window).width()<=768){
      $('.google_popup .pop_detail img').attr('srcset','https://cdn.shopify.com/s/files/1/1720/3725/files/m_2x_7ce48c28-430d-4575-9dfa-5a0457926cf4.png?v=1745303987');
   }else{
      $('.google_popup .pop_detail img').attr('srcset','https://cdn.shopify.com/s/files/1/1720/3725/files/pc_5b4b6b28-8ac9-430d-a4c1-492ce86ff2c2.png?v=1745303987');
   }

    setTimeout(function(){
     jQuery('.google_popup .window-cover').show();
     jQuery('.google_popup .pop_main').show();
      jQuery('.google_popup .pop_detail_button').remove();
     jQuery('.google_popup .pop_main .pop_con').css({'top':0,'opacity':0})
     jQuery('.google_popup .pop_main .pop_con').animate({'top':'50%','opacity':1})
    }, 1000);

}

  // 获取参数名称
function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}
$(document).ready(function(){

    if(jQuery(window).width()>768){
      $('.myVideo').attr('controls', '')
    }
  $('.quick_payment .shopify-cleanslate .xGd3h1QpIzYq8GCXdELr li:gt(1)').hide();
    var $gallery = $('.big_pic-product .flickity-slider');
    var $images = $gallery.find('.Carousel__Cell');
    var lastIndex = $images.length - 1;
 
    $gallery.scroll(function() {
        var scrollLeft = $gallery.scrollLeft(); // 当前滚动位置
        // 判断是否滑动到最后一张图片
        if (scrollLeft >= $images.eq(lastIndex).position().left) {
            // 在这里执行你需要的操作
        }
    });
});
$(document).ready(function(){
  $(".muteButton").each(function () {
    // 点击音量按钮
    $(this).click(function(){
      var video = $(this).parent().siblings()[0]; // 转换为原生DOM对象
      video.muted = !video.muted; // 切换静音状态
      if($(this).find('.iconfont').hasClass('icon-Volume')){
        $(this).find('.iconfont').removeClass('icon-Volume').addClass('icon-Volume-Up');
      }else{
         $(this).find('.iconfont').removeClass('icon-Volume-Up').addClass('icon-Volume');
      }
    });
  })
  
  $(".playBtn").each(function () {
    $(this).click(function(){
      // 点击播放
      var video = $(this).parent().siblings()[0]; // 获取video DOM对象
      if(video){
        if (video.paused) {
          // 开始播放
          $('.muteButton').hide();
           video.play(); // 播放视频
          $(this).attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552');
        }else{
          // 停止播放
          $('.muteButton').show();
            video.pause(); //暂停控制
            $(this).attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552');
        }
        // 进度条
        var progressBar = $(this).siblings('.progressBarContainer').find('.progressBar');
        var handleProgress = function(){
          var percentage = (100 / video.duration) * video.currentTime;
          progressBar.css('width', percentage + '%');
        };
       
        video.addEventListener('timeupdate', handleProgress, false);
      }

    });
  })
  // 判断图片滑动的方向
  let startX, startY, distX, distY, threshold = 150; // 定义一个阈值来判断是否触发了滑动
   $('.big_pic .flickity-viewport .Carousel__Cell').each(function(index){
      $(this).on('touchstart', function(e) {
        startX = e.originalEvent.touches[0].pageX;
        startY = e.originalEvent.touches[0].pageY;
        // 记录开始触摸的位置
      });
      $(this).on('touchmove', function(e) {
        e.preventDefault();
        var endX, endY, direction;
        endX = e.originalEvent.touches[0].pageX;
        endY = e.originalEvent.touches[0].pageY;
        // 计算水平和垂直方向的位移
        var deltaX = endX - startX;
        var deltaY = endY - startY;
     
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // 水平方向移动
            if (deltaX > 0) {
                direction = 'right';
                // 往又有移动
                if($(this).attr('data-index')>1 && $(this).attr('data-index')<$('.big_pic .flickity-viewport .Carousel__Cell').length-3){
                  var pic_index=$(this).attr('data-index');
                  left_width="-" +(21*Number(pic_index-2));
                  $('.Product__SlideshowMobileNav .flickity-page-dots').css('margin-left',left_width+'px');
 
                }
            } else {
              // 往左左移动
                direction = 'left';
                if($(this).attr('data-index')>1 && $(this).attr('data-index')<$('.big_pic .flickity-viewport .Carousel__Cell').length-3){
                  var pic_index=$(this).attr('data-index');
                  left_width="-" +(21*pic_index);
                  $('.Product__SlideshowMobileNav .flickity-page-dots').css('margin-left',left_width+'px');
                }
            }
        } else {
            // 垂直方向移动
            if (deltaY > 0) {
                direction = 'down';
            } else {
                direction = 'up';
            }
        }
        // distX = e.originalEvent.changedTouches[0].pageX - startX;

   
          // 可以在这里添加更多的滑动逻辑，比如限制滑动的方向等
      });
     
    $(this).on('touchend', function(e) {
      distX = e.originalEvent.changedTouches[0].pageX - startX;
      distY = e.originalEvent.changedTouches[0].pageY - startY;
      // 根据水平方向的位移判断滑动方向
      if (Math.abs(distX) > threshold) {
        if (distX > 3) {
          // 向右滑动
          if($(this).attr('data-index')>2){
            if($(this).attr('data-index')<=1){
            }else{
              if($(this).attr('data-index')==$('.big_pic .flickity-viewport .Carousel__Cell').length-1){
                // 点击的最后一张
                $('.last_tips').remove();
              }
            }

          }
        } else {
          // 向左滑动
          if($(this).attr('data-index')>2){
            if($(this).attr('data-index')>=$('.big_pic .flickity-viewport .Carousel__Cell').length-2){
              // 最后一张
              $(this).append('<div class="last_tips"><span class="iconfont icon-Information-circle"></span>last picture</div>')
            }else{
            }

          }

          // 滑动一次，向左滚动一次
        }
      }
    });
  })

});

// DataLyer传值内容
function product_cart_DataLyer_push(button_name,total_price,product_name,product_id,sku_word,quantity) {
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
      event: "dle_add_to_cart",
      dlv_ea: 'productAdd',
      dlv_el: button_name,
      dlv_cu: 'USD',
      dlv_val: total_price,
      ecommerce: {
          items: [{
            item_name: product_name,
            item_id: product_id,
            price: total_price,
            item_brand: sku_word,
            quantity: quantity,
            currency: 'USD',
          }]
      }
  });
}